export default __webpack_public_path__ + "static/media/khelp.3a918eca.png";